<!-- Root App.svelte -->

<script>
  import { onMount } from 'svelte';
  import Router from 'svelte-spa-router';
  import Home from './Home/FocalPathLanding.svelte';
  import HomeV3 from './Home/HomeV3.svelte';
  import HomeV4 from './Home/HomeV4.svelte';
  import TopPriorityLanding from './Home/TopPriorityLanding.svelte';
  import FocalPath from './FocalPath/FocalPathApp.svelte';
  import TopPriorityApp from './FocalPath/TopPriorityApp.svelte';
  import Why from './Why/Why.svelte';
  import CookieConsent from './components/CookieConsent.svelte';
  import analytics from './utils/analytics.js';

  // Detect if we're on the TopPriority subdomain
  const isTopPrioritySubdomain = window.location.hostname.toLowerCase().startsWith('toppriority.');

  // Routes differ based on subdomain - TopPriority subdomain shows TopPriority landing at root
  const routes = {
    '/': isTopPrioritySubdomain ? TopPriorityLanding : Home,
    '/v3': HomeV3,
    '/v4': HomeV4,
    '/TopPriority': TopPriorityLanding,
    '/DeciderApp': FocalPath,
    '/TopPriorityApp': TopPriorityApp,
    '/Why': Why,
    // catch-all
    // '*': () => import('./NotFound.svelte')
  };

  onMount(() => {
    // Initialize analytics tracking
    analytics.trackPageView('app_loaded', {
      timestamp: Date.now(),
      userAgent: navigator.userAgent,
      referrer: document.referrer,
      isTopPrioritySubdomain: isTopPrioritySubdomain
    });
  });
</script>

<Router {routes} useHash={false}/>

<!-- Cookie Consent Banner -->
<CookieConsent />


<!-- Me llevé los estilos globales a  src/global.css -->
<!-- <style>                                 
  /* global styles */

  :global(body) {
    /* background-color: #DBC7BE; */
    background-color: #ffffff;
    /* filter: brightness(50%); */
  }

  :global(button) {
    padding: 8px 15px;
    margin: 10px 0;
    background-color: #9CFFFA; /* Set the background color; teal */
    /*background-color: #00b4d8;  Set the background color; teal */
    color: #084B83; /* Set the button text color to white for better contrast */
    border: none; /* Remove any default borders */
    border-radius: 10px; /* Optional: Rounded corners */
    cursor: pointer; /* Optional: Change cursor to a hand pointer on hover */
  }

  :global(button:hover) {
    background-color: #FFEC6C; /* Optional: Slightly darker shade for a hover effect */
    /*background-color: #0077b6;  Optional: Slightly darker shade for a hover effect */
    box-shadow: 0 6px 12px rgba(0,0,0,0.2); /* deeper shadow on hover */
  }
  :global(button:active) {
    transform: scale(0.95);
  }
  :global(button.remove-button) {
    /* background-color: #AF9BB6; */
    background-color: rgb(233, 230, 230);
    /* background-color: lightgrey; */
  }

  	:global(button.delete:hover) {     												
		background-color: #EF8275; /*Darken button on hover for feedback*/
	}

  :global(input[type="text"], textarea){
    border-radius: 10px;
    /* border: 1px solid; */
    border: 1px solid #ccc;
    margin-right: 1em;
  }
  
  :global(input[type="text"]:focus, textarea:focus) {
    outline: 2px solid #9CFFFA;    
    /* outline: 1px solid #007bff;     */
    /* Por alguna razón este estilo no está funcionando */
  }

  :global(.Slider input[type="range"]) {
    width: 100%;
    margin: 10px 0;
  }

  :global(.Slider .value) {
    text-align: right;
    font-weight: normal;
  }


  /* @import url('https://fonts.googleapis.com/css2?family=IBM+Plex+Mono:wght@200&display=swap'); */
  
  :global(body) {
    /* font-family: 'Roboto', sans-serif; */
    font-family: 'IBM Plex Mono', monospace !important;
  }

  /* Testing */

  
</style> -->
